import { isMobileAuthMode } from "../mobileAuthBridge";
import { FakeAuthAdapter } from "./adapters/FakeAuthAdapter";
import { MobileAuthAdapter } from "./adapters/MobileAuthAdapter";
import { WebAuthAdapter } from "./adapters/WebAuthAdapter";
import { IAuthAdapter } from "./types";

export const createAuthAdapter = (): IAuthAdapter => {
  if (isMobileAuthMode()) return new MobileAuthAdapter();
  if (process.env.REACT_APP_FAKE_AUTH === "true") return new FakeAuthAdapter();

  return new WebAuthAdapter();
};
